/**
 * Brera · Compra el look (sections/shop-the-look.liquid)
 * - Puntos: abre y cierra la tarjeta de cada prenda (clic fuera o Esc la cierra).
 * - Lista: talla/color por prenda con su precio, total del look, "Agregar" por prenda y "Agregar el look completo".
 *   Al pasar por una prenda se resalta su punto en la foto (y al revés).
 * El "+" y "Agregar" de las tarjetas usan assets/quick-add.js (data-quick-add).
 */
(() => {
  if (window.BreraLook) return;
  const B = window.Brera || {};
  const root = (B.routes && B.routes.root) || '/';
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);

  const formatMoney = (cents) => {
    if (window.BreraQuickAdd && window.BreraQuickAdd.formatMoney) return window.BreraQuickAdd.formatMoney(cents);
    const m = B.money || {};
    const fmt = m.format || '${{amount}}';
    const value = (cents || 0) / 100;
    const build = (decimals, thousands, decimal) => {
      let [int, dec] = value.toFixed(decimals).split('.');
      int = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      if (dec && m.decimals !== 'always' && /^0+$/.test(dec)) dec = '';
      return dec ? int + decimal + dec : int;
    };
    const out = fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount_no_decimals': return build(0, ',', '.');
        case 'amount_with_comma_separator': return build(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return build(0, '.', ',');
        case 'amount_with_apostrophe_separator': return build(2, "'", '.');
        default: return build(2, ',', '.');
      }
    });
    return m.code ? out + ' ' + m.code : out;
  };

  const addItems = async (items) => {
    const res = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items }),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || '');
    const cart = await fetch(root + 'cart.js').then((r) => r.json());
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.classList.toggle('is-empty', cart.item_count === 0);
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    return data;
  };

  /* ---------- Puntos y tarjetas ---------- */
  const closeAll = (scope, except) => {
    scope.querySelectorAll('.look-dot[aria-expanded="true"]').forEach((dot) => {
      if (dot === except) return;
      dot.setAttribute('aria-expanded', 'false');
      const pop = document.getElementById(dot.getAttribute('aria-controls'));
      if (pop) pop.hidden = true;
    });
  };

  const initDots = (section) => {
    section.querySelectorAll('.look-dot[aria-controls]').forEach((dot) => {
      dot.addEventListener('click', () => {
        const pop = document.getElementById(dot.getAttribute('aria-controls'));
        const open = dot.getAttribute('aria-expanded') !== 'true';
        closeAll(section, dot);
        dot.setAttribute('aria-expanded', open);
        if (pop) pop.hidden = !open;
      });
    });
    section.querySelectorAll('[data-look-close]').forEach((b) =>
      b.addEventListener('click', () => closeAll(section))
    );
    // Clic fuera de la tarjeta la cierra (sin cortar el clic, que lo necesita el agregado rápido)
    document.addEventListener('click', (e) => {
      if (e.target.closest('.look-pop, .look-dot, .quick-add-sheet')) return;
      closeAll(section);
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll(section);
    });
  };

  /* ---------- Lista ---------- */
  const initList = (section) => {
    const items = [...section.querySelectorAll('[data-look-item]')];
    if (!items.length) return;
    const dots = [...section.querySelectorAll('[data-look-dot]')];
    const totalEl = section.querySelector('[data-look-total]');
    const msg = section.querySelector('[data-look-msg]');

    const selected = (item) => {
      const input = item.querySelector('[data-look-variant]');
      if (!input) return null;
      if (input.tagName === 'SELECT') {
        const opt = input.selectedOptions[0];
        return opt && !opt.disabled ? { id: Number(opt.value), price: Number(opt.dataset.price), compare: Number(opt.dataset.compare || 0) } : null;
      }
      return { id: Number(input.value), price: Number(input.dataset.price) };
    };

    const updateTotal = () => {
      if (!totalEl) return;
      const sum = items.reduce((acc, item) => {
        if (item.classList.contains('is-sold-out')) return acc;
        const v = selected(item);
        return v ? acc + v.price : acc;
      }, 0);
      totalEl.textContent = formatMoney(sum);
    };

    const say = (html, error) => {
      if (!msg) return;
      msg.innerHTML = html;
      msg.classList.toggle('is-error', !!error);
    };
    const added = () => `${esc(section.dataset.added)} · <a href="${root}cart">${esc(section.dataset.viewCart)}</a>`;

    items.forEach((item, i) => {
      const select = item.querySelector('select[data-look-variant]');
      if (select) {
        select.addEventListener('change', () => {
          const v = selected(item);
          const price = item.querySelector('[data-look-price]');
          if (v && price) {
            const current = price.querySelector('.price__current');
            if (current) current.textContent = formatMoney(v.price);
            const compare = price.querySelector('.price__compare');
            if (compare) compare.hidden = !(v.compare > v.price);
            price.classList.toggle('price--on-sale', v.compare > v.price);
          }
          updateTotal();
        });
      }

      const addOne = item.querySelector('[data-look-add-one]');
      if (addOne) {
        addOne.addEventListener('click', async () => {
          const v = selected(item);
          if (!v) return;
          addOne.classList.add('is-loading');
          try {
            await addItems([{ id: v.id, quantity: 1 }]);
            say(added());
          } catch (e) {
            say(esc(e.message || section.dataset.error), true);
          }
          addOne.classList.remove('is-loading');
        });
      }

      // Resaltar el punto de la prenda y al revés
      const dot = dots[i];
      if (dot) {
        const on = () => { dot.classList.add('is-highlighted'); item.classList.add('is-highlighted'); };
        const off = () => { dot.classList.remove('is-highlighted'); item.classList.remove('is-highlighted'); };
        item.addEventListener('mouseenter', on);
        item.addEventListener('mouseleave', off);
        dot.addEventListener('mouseenter', on);
        dot.addEventListener('mouseleave', off);
        if (!dot.hasAttribute('aria-controls')) {
          dot.addEventListener('click', () => item.scrollIntoView({ behavior: 'smooth', block: 'center' }));
        }
      }
    });

    const addAll = section.querySelector('[data-look-add-all]');
    if (addAll) {
      addAll.addEventListener('click', async () => {
        const list = items
          .filter((item) => !item.classList.contains('is-sold-out'))
          .map(selected)
          .filter(Boolean)
          .map((v) => ({ id: v.id, quantity: 1 }));
        if (!list.length) return;
        addAll.classList.add('is-loading');
        try {
          await addItems(list);
          say(added());
        } catch (e) {
          say(esc(e.message || section.dataset.error), true);
        }
        addAll.classList.remove('is-loading');
      });
    }

    updateTotal();
  };

  const init = (scope) => {
    scope.querySelectorAll('[data-look]').forEach((section) => {
      if (section.dataset.ready) return;
      section.dataset.ready = '1';
      initDots(section);
      initList(section);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);

  // Editor del tema: al seleccionar una prenda se abre su tarjeta
  document.addEventListener('shopify:section:load', (e) => init(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const dot = e.target.closest && e.target.closest('.look-dot[aria-controls]');
    if (dot && dot.getAttribute('aria-expanded') !== 'true') dot.click();
  });

  window.BreraLook = { init };
})();
